// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tKzG","field":"styles_field__3uaNm","fieldCol":"styles_fieldCol__2l8jr","diffCol":"styles_diffCol__1CHek","diff":"styles_diff__3NvBn"};